<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-fussion" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<div class="container">
    <div class="common loginformsection">				
        <div class="loginform">
            <div class="logodiv text-center">
                <img src="assets/images/logo.png">
            </div>
            
            <h6 class="formheading">Reset your password</h6>
            <form [formGroup]="reset_password_form" (ngSubmit)="reset_password_submit()">
                <div class="form-group">						  
                  <input type="password" class="form-control email inptdesgn" id="password" placeholder="Password" formControlName="password" (keyup) = "enterPassword($event.target.value)">
                  <span *ngIf="passwordFormSubmit && reset_password_f.password.invalid ; else passwordError" class="inputValidation">Password is required.</span>
                  <ng-template #passwordError><span class="inputValidation">{{ validPasswordMsg }}</span></ng-template>
                </div>
                <div class="form-group mgbtmless">						  
                  <input type="password" class="form-control pwd inptdesgn" id="confirm_password" placeholder="Confirm Password" formControlName="confirm_password" (keyup)="confirmPassword()"> 
                    <div *ngIf="passwordFormSubmit && reset_password_f.confirm_password.errors">
                        <span *ngIf="passwordFormSubmit && reset_password_f.confirm_password.errors.required" class="inputValidation">Confirm Password is required.</span> 
                    </div>
                    <span class="inputValidation">{{confirmPasswordMsg}}</span>
                </div>
                <div class="form-group text-center">
                    <input type="submit" class="sgninbtn smallhndrd" name="sgninbtn" value="Submit" [disabled] = "validPassword ? false : true">
                </div>
            </form>
            
        </div>
    </div>
</div>